import script from "./HRDiagramOutput.vue?vue&type=script&setup=true&lang=js"
export * from "./HRDiagramOutput.vue?vue&type=script&setup=true&lang=js"

import "./HRDiagramOutput.vue?vue&type=style&index=0&id=2a488ad6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a488ad6"]])

export default __exports__